import styled from "@emotion/styled";
import { Separator } from "react-aria-components";

export const StyledDivider = styled(Separator)`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  margin-block: ${({ theme }) => theme.spacing[1]};
`;
